import React from "react";
import ItemCard from "@/items/components/ItemCard";
const EventItemCard = (props) => {
  const { 
    event,
    hold,
    item,
    removeHold
  } = props;


  return (
    <ItemCard 
      event={event}
      hold={hold}
      item={item}
      removeHold={removeHold}
      onClose = {(changes)=> {
        console.log("EVNETITemCard onClose", changes);
        if(changes) {
          window.location.reload();
        }
      }}
    />
  )
}

export default EventItemCard